"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/** specific functions and variables for test environment purposes */
exports.popoverTestUtils = {
    createRange: function () {
        document.createRange = function () {
            return ({
                setStart: function () { return null; },
                setEnd: function () { return null; },
                commonAncestorContainer: document.documentElement.querySelector('body'),
            });
        };
    },
    generateId: function () {
        return Math.floor((1 + Math.random()) * 0x10000)
            .toString(16)
            .substring(1);
    },
};
//# sourceMappingURL=helpers.js.map


//////////////////
// WEBPACK FOOTER
// ../node_modules/wix-ui-core/dist/src/components/popover/helpers.js
// module id = 1265
// module chunks = 0